import {css} from "styled-components";
import {getFontSize, getFontWeight, getLetterSpacing, getLineHeight} from "@/pipes/theme.pipe";


const sizeOptions = {
    xs: css`
        font-size: ${getFontSize('headline', 'xs')};
        font-weight: ${getFontWeight('400')};
        line-height: ${getLineHeight('headline', 'xs')};
    `,
    sm: css`
        font-size: clamp(${getFontSize('headline', 'xs')}, 4vw, ${getFontSize('headline', 'sm')});
        font-weight: ${getFontWeight('600')};
        line-height: ${getLineHeight('headline', 'xs')};
    `,
    md: css`
        font-size: clamp(${getFontSize('headline', 'sm')}, 4vw, ${getFontSize('headline', 'md')});
        font-weight: ${getFontWeight('600')};
        line-height: clamp(${getLineHeight('headline', 'sm')}, 4vw, ${getLineHeight('headline', 'md')});
    `,
    lg: css`
        font-size: clamp(${getFontSize('headline', 'sm')}, 4vw, ${getFontSize('headline', 'lg')});
        font-weight: ${getFontWeight('600')};
        line-height: clamp(${getLineHeight('headline', 'xs')}, 4vw, ${getLineHeight('headline', 'md')});
    `,
    xl: css`
        font-size: clamp(${getFontSize('headline', 'sm')}, 5vw, ${getFontSize('headline', 'xl')});
        font-weight: ${getFontWeight('600')};
        line-height: clamp(${getLineHeight('headline', 'xs')}, 6vw, ${getLineHeight('headline', 'xl')});
        letter-spacing: clamp(${getLetterSpacing('lg')}, 4vw, ${getLetterSpacing('xl')});
    `,
    'xs:subtitle': css`
        font-size: ${getFontSize('subtitle', 'xs')};
        font-weight: ${getFontWeight('400')};
        line-height: ${getLineHeight('subtitle', 'xs')};
    `,
    'sm:subtitle': css`
        font-size: clamp(${getFontSize('subtitle', 'xs')}, 2vw, ${getFontSize('subtitle', 'sm')});
        font-weight: ${getFontWeight('400')};
        line-height: ${getLineHeight('headline', 'xs')};
    `,
    'md:subtitle': css`
        font-size: clamp(${getFontSize('subtitle', 'sm')}, 5vw, ${getFontSize('subtitle', 'md')});
        font-weight: ${getFontWeight('600')};
        line-height: clamp(${getLineHeight('subtitle', 'xs')}, 6vw, ${getLineHeight('subtitle', 'lg')});
    `,
    'lg:subtitle': css`
        font-size: clamp(${getFontSize('subtitle', 'md')}, 5vw, ${getFontSize('subtitle', 'lg')});
        font-weight: ${getFontWeight('600')};
        line-height: clamp(${getLineHeight('subtitle', 'md')}, 6vw, ${getLineHeight('subtitle', 'xl')});
        letter-spacing: clamp(${getLetterSpacing('md')}, 4vw, ${getLetterSpacing('lg')});
    `
};

export const getSizeStyles = ({size}) => sizeOptions[size] ?? sizeOptions['md']